import * as React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

interface FormattedMessageProps {
	id?: string;
	intl: IntlShape;
}

interface FormattedMessageState {}

export class FormattedMessage extends React.Component<
	FormattedMessageProps,
	FormattedMessageState
> {
	public getMessage(id: string): string {
		return this.props.intl.formatMessage({ id: id });
	}

	render() {
		const { intl } = this.props;
		const message = intl.formatMessage({ id: this.props.id });

		return <span dangerouslySetInnerHTML={{ __html: message }} />;
	}
}

export default injectIntl(FormattedMessage);
